var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToConfirmOrderStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    rx: 7.5,
    fill: "#FFFBF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12793_57140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8015 6.2742L16.8015 6.27419L16.801 6.26832C16.7914 6.15789 16.8058 6.04651 16.8438 5.9409C16.8817 5.83524 16.9427 5.73693 17.0238 5.65262C17.105 5.56825 17.2047 5.49976 17.3171 5.45241C17.4296 5.40505 17.5518 5.38015 17.6759 5.37977L17.6796 5.37972C18.1426 5.37367 18.6124 5.37367 19.079 5.37838C19.7028 5.38612 20.0827 5.85599 19.9867 6.40163L19.9867 6.40169C19.9393 6.67172 19.8909 6.94184 19.8425 7.21265C19.794 7.48326 19.7455 7.75455 19.6978 8.02595L19.6976 8.02678C19.631 8.41106 19.9173 8.7148 20.2299 8.77733C20.2589 8.78315 20.2878 8.78889 20.3164 8.79459C20.5158 8.83434 20.7041 8.87187 20.8908 8.91646C21.0162 8.94642 21.1389 8.97889 21.2651 9.01355C21.2652 9.01357 21.2652 9.01359 21.2653 9.01361C21.2661 9.01458 21.2681 9.01727 21.27 9.02237C21.275 9.03645 21.2733 9.05195 21.2664 9.06346C20.6626 10.0691 20.4478 11.1539 20.6541 12.3161C20.8346 13.3397 21.3581 14.2768 22.142 14.9879C23.4917 16.2429 25.9212 16.9041 28.2131 15.6545C28.2185 15.6515 28.2239 15.6501 28.229 15.6497C28.2327 15.6494 28.2359 15.6497 28.2384 15.6502C28.5458 16.6762 28.6907 17.7401 28.6682 18.8068H8.1512C8.09284 16.4061 8.7768 14.2425 10.3509 12.3471C11.9297 10.4459 13.9744 9.2798 16.4699 8.79325C16.8671 8.7158 17.1462 8.33563 17.0751 7.92277C17.0136 7.56563 16.9533 7.21466 16.8937 6.86342L16.524 6.92611L16.8938 6.86419C16.8821 6.79409 16.8703 6.72997 16.8593 6.6696C16.8331 6.52689 16.8108 6.40505 16.8015 6.2742Z",
    fill: "#FFFBF5",
    stroke: "url(#paint0_linear_12793_57140)",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4238 20.9547H30.1835C30.6971 20.9547 30.8164 21.0943 30.8171 21.6922C30.8171 22.0085 30.8128 22.3257 30.8171 22.642C30.8232 22.7529 30.8029 22.8635 30.7585 22.9613C30.714 23.0591 30.6472 23.1402 30.5657 23.1951C30.0285 23.5901 29.4942 23.9944 28.9542 24.3792C28.8391 24.456 28.7091 24.4962 28.577 24.4959C21.7977 24.5016 15.018 24.5016 8.23772 24.4959C8.09761 24.4926 7.96058 24.4466 7.83985 24.3623C7.32055 23.9944 6.81338 23.6011 6.29622 23.2298C6.09407 23.0844 5.99193 22.8957 6.0005 22.6099C6.0105 22.2614 6.0005 21.913 6.0005 21.5654C6.00478 21.1357 6.15693 20.9564 6.52695 20.9564C7.9789 20.9564 9.43134 20.9564 10.8842 20.9564L18.4238 20.9547Z",
    fill: "url(#paint1_linear_12793_57140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6074 14.3057C28.6875 14.3057 30.3738 12.6194 30.3738 10.5393C30.3738 8.45912 28.6875 6.77283 26.6074 6.77283C24.5272 6.77283 22.8409 8.45912 22.8409 10.5393C22.8409 12.6194 24.5272 14.3057 26.6074 14.3057Z",
    fill: "url(#paint2_linear_12793_57140)",
    stroke: "url(#paint3_linear_12793_57140)",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6074 8.38696V10.5392L27.6835 11.6153",
    fill: "url(#paint4_linear_12793_57140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6074 8.38696V10.5392L27.6835 11.6153",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12793_57140",
    x: 5.25,
    y: 4.25,
    width: 27.8182,
    height: 22.5002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.75,
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.192157 0 0 0 0 0.239216 0 0 0 0 0.682353 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12793_57140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12793_57140",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12793_57140",
    x1: 6.8864,
    y1: 7.65909,
    x2: 28.1591,
    y2: 19.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#FFA14A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12793_57140",
    x1: -0.204545,
    y1: 20.9547,
    x2: 29.0455,
    y2: 24.9433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#FFA14A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12793_57140",
    x1: 23.2841,
    y1: 6.77283,
    x2: 27.7159,
    y2: 9.8751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#FFA14A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12793_57140",
    x1: 26.6074,
    y1: 6.77283,
    x2: 26.6074,
    y2: 14.3057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#FFA14A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12793_57140",
    x1: 26.6707,
    y1: 8.38696,
    x2: 27.5654,
    y2: 8.59571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#FFA14A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7B00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToConfirmOrderStatus);
export default __webpack_public_path__ + "static/media/to-confirm-order-status.d580b62f5f2a3e35b3891bae9340b4e9.svg";
export { ForwardRef as ReactComponent };